<template>
    <v-btn class="IconTextButton" :class="[buttonClass, { 'outlined': outlined }]" elevation="0" @click="handleClick"
        :disabled="disabled" color="black">
        <v-icon class="mr-1">{{ icon }}</v-icon>
        {{ buttonText }}
    </v-btn>
</template>

<script>
export default {
    name: 'IconTextButton',
    props: {
        icon: {
            type: String,
            default: 'mdi-pencil'
        },
        buttonText: {
            type: String,
            default: 'Edit'
        },
        buttonClass: {
            type: String,
            default: 'IconTextButton'
        },
        outlined: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        handleClick() {
            this.$emit('click');
        }
    }
};
</script>

<style scoped>
.IconTextButton {
    color: #fff;
}
</style>
